import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-08b86da8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10 flex justify-center" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-3" }
const _hoisted_3 = { class: "row-span-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border animate-spin inline-block w-16 h-16 border-4 rounded-full",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mx-auto p-2" }
const _hoisted_8 = {
  class: "inline-flex rounded-md shadow-sm",
  role: "group"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Dry Off")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Go Swim ")
const _hoisted_11 = {
  key: 0,
  class: "navText text-2xl"
}
const _hoisted_12 = { class: "row-span-2" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border animate-spin inline-block w-16 h-16 border-4 rounded-full",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NFTGrid = _resolveComponent("NFTGrid")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_NFTGrid, {
          title: "vault",
          class: "flex-1 box",
          nfts: _ctx.desiredWalletNFTs,
          onSelected: _ctx.handleWalletSelected
        }, null, 8, ["nfts", "onSelected"]),
        (_ctx.walletLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            disabled: _ctx.vaultLocked,
            class: "refreshButton navText nav-button text-2xl disabled:opacity-50",
            left: true,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.moveNFTsFE(true)))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_Button, {
            disabled: _ctx.vaultLocked,
            class: "refreshButton navText nav-button text-2xl disabled:opacity-50",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveNFTsFE(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        (_ctx.vaultLocked)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Your ducks are currently swimming "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.bank && _ctx.vault)
          ? (_openBlock(), _createBlock(_component_NFTGrid, {
              key: 0,
              title: "wallet",
              class: "flex-1 box",
              nfts: _ctx.desiredVaultNFTs,
              onSelected: _ctx.handleVaultSelected
            }, null, 8, ["nfts", "onSelected"]))
          : _createCommentVNode("", true),
        (_ctx.vaultLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}